export enum ConsultanciesTypeEnum {
  CONSULTANCIES_IN_THE_HIRING_PROCESS,
  CONSULTANCIES_IN_EXECUTION,
}
